/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Dance_FitnessInputs */

const en_service_type_dance_fitness = /** @type {(inputs: Service_Type_Dance_FitnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dance fitness`)
};

const pl_service_type_dance_fitness = /** @type {(inputs: Service_Type_Dance_FitnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zumba i taniec`)
};

/**
* | output |
* | --- |
* | "Dance fitness" |
*
* @param {Service_Type_Dance_FitnessInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_dance_fitness = /** @type {((inputs?: Service_Type_Dance_FitnessInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Dance_FitnessInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_dance_fitness(inputs)
	return en_service_type_dance_fitness(inputs)
});